import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'saving': false,
  'list': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const salesAndBudgetsLoad = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_SALES_AND_BUDGETS_DATA]: (state, action) => ({
      ...state,
      'saving': false,
      'list': [],
      'page': [],
      'pageSize': 20,
      'pageNumber': 0,
    }),
    [ActionTypes.SAVE_SALES_AND_BUDGETS_DATA_FROM_EXCEL]: (state, action) => ({
      ...state,
      'list': action.payload,
      'page': [...getPage(action.payload, 0, state.pageSize)],
    }),
    [ActionTypes.CREATING_SALES_AND_BUDGETS]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.CREATED_SALES_AND_BUDGETS]: (state, action) => ({
      ...state,
      'saving': false,
      'list': [],
      'page': [],
    }),
    [ActionTypes.CREATED_SALES_AND_BUDGETS_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.CHANGE_SALES_AND_BUDGETS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'page': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_SALES_AND_BUDGETS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'page': [...getPage(state.list, 0, action.payload)],
    }),
  })(state, action);
};
